import axios from 'axios'

const apiAuth = axios.create({
  baseURL: 'https://mns.gelogs.co.th/api/',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiAuth.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiAuth
